<template>
  <v-row class="root">
    <v-col>
      <v-skeleton-loader class="header-loading-1" :loading="loading" type="heading">
        <h1>{{title}}</h1>
      </v-skeleton-loader>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: ['title', 'loading']
}
</script>

<style scoped>
.root >>> .v-skeleton-loader__heading {
  background-color: #E4E6EB !important;
}
h1 {
  font-weight: bold;
  font-size: 2rem;
  line-height: 2.4375rem;
  letter-spacing: 0.1px;
  color: #234025;
}
@media screen and (max-width: 600px) {
  h1 { 
    font-size: 0.9375rem;
  }
}
</style>